export const REPORT_ISSUE = "report-issue";

export type ReportIssueDetail = { facts: [string, string][] };

export function askToReportIssue(from: EventTarget, facts: [string, string][] = []): void {
  from.dispatchEvent(new CustomEvent<ReportIssueDetail>(REPORT_ISSUE, { detail: { facts }, bubbles: true, composed: true }));
}
